(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mg-home-editorial"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    root.querySelectorAll('.mg-home').forEach(function(home){
      if(home.dataset.railReady)return;
      home.dataset.railReady='true';
      var rail=home.querySelector('.mg-home__rail'),arrows=home.querySelector('.mg-home__arrows');
      if(!rail||!arrows)return;
      var buttons=arrows.querySelectorAll('button');
      function state(){arrows.hidden=rail.scrollWidth<=rail.clientWidth+3;buttons[0].disabled=rail.scrollLeft<3;buttons[1].disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-3;}
      buttons.forEach(function(button){button.addEventListener('click',function(){var card=rail.querySelector('.mg-home__card');var gap=parseFloat(getComputedStyle(rail).gap)||18;var step=card.getBoundingClientRect().width+gap;var count=Math.max(1,Math.floor((rail.clientWidth+gap)/step));rail.scrollBy({left:Number(button.dataset.mgDirection)*step*count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});});
      rail.addEventListener('scroll',state,{passive:true});
      var observer=new ResizeObserver(state);
      observer.observe(rail);
      function unload(event){if(event.target.contains(home)){observer.disconnect();document.removeEventListener('shopify:section:unload',unload);}}
      document.addEventListener('shopify:section:unload',unload);
      state();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load',function(event){setup(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
